import { useState, useEffect } from 'react';
import axios from 'axios';
import Loader from "react-loader-spinner";
import './Genres.scss';
import Banner from '../../components/Banner/Banner';
import { url, token } from '../../utils/Config/config';
import { NavLink } from 'react-router-dom';

const Genres = () => {
    const [genres, setGenres] = useState([]);
    const [loading, setLoading] = useState(false);

    const getGenres = async () => {
        setLoading(true);
        try {
           let response = await axios.get(`${url}/genres?key=${token}`);
           setGenres(response.data.results);
           setLoading(false);
        } catch(e) {
            setLoading(true);
            console.log(e.message);
        }
    }

    useEffect(() => {
        getGenres();
    }, []);

    return (
        <div className="Genres">
            <Banner 
                bannerTitle="All Genres"
            />
            {loading ?
                <Loader
                className="loader"
                type="ThreeDots"
                color="#dc3545"
                height={60}
                width={60}
              /> : 
                <div className="container">
                <div className="row justify-content-between my-5">
                {genres.map((genre, index) => {
                    return(
                        <div className="col-md-4 my-3" key={index}>
                            <NavLink className="card-link" to={`/genres/${genre.slug}`}>
                                <div className="card">
                                    <div className="card-body" style={{
                                        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${(genre.image_background)})`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        borderRadius: '25px'
                                    }}>
                                        <h3 className="text-white text-center py-5">{genre.name}</h3>
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    );
                })}
                </div>
            </div>
            }
            
        </div>
    );
};

export default Genres;
